import { ControlEventType, ControlPropertyType } from '../../../enums';

export const RatingItemPropertyType = {
  ...ControlPropertyType,
  CheckedIcon: 'checkedIcon',
  UncheckedIcon: 'uncheckedIcon',
  Size: 'size',
  ColorScheme: 'colorScheme',
};

export const RatingPropertyType = {
  ...RatingItemPropertyType,
  Options: 'options',
};

export const RatingEventType = {
  ...ControlEventType,
};
